'use client'

import { useEffect } from 'react'
import { CoralogixRum } from '@coralogix/browser'
import { isBotRequest } from '@/utils/browser'

interface CoralogixRumInitProps {
  shopVersion: string | null
}

export default function CoralogixRumInit({
  shopVersion,
}: CoralogixRumInitProps) {
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      process.env.NEXT_PUBLIC_ENABLE_CORALOGIX === 'true'
    ) {
      // JS-executing crawlers (meta-externalads, rendering Googlebot, …)
      // boot the full client app, so without this guard every crawl becomes
      // a RUM session: it burns RUM quota and pollutes error-rate dashboards
      // with bot-only noise (e.g. 401s from session-less bot fetches).
      if (isBotRequest(navigator.userAgent)) return

      CoralogixRum.init({
        public_key: process.env.NEXT_PUBLIC_CORALOGIX_RUM_KEY!,
        application: 'Oddle Shop 2025',
        version: shopVersion || '1.0.0',
        coralogixDomain: 'AP2',
      })
    }
  }, [shopVersion])

  return null
}
